import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Tiplist} from 'shared/models/tips/tiplist';

@Injectable()
export class TipListOverviewRepository {

  constructor(private http: Http) { }

  public getTiplists(): Observable<Array<Tiplist>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.tiplists}?withRating=true`, options)
      .map((tiplists: Response) => {
        return tiplists.json();
      });
  }

  public deleteTiplist(id: string): Observable<Response> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.delete(`${environment.tiplists}/${id}`, options);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-overview/repositories/tip-list-overview.repository.ts